<template>
	<div class="container" id="topTarget" @scroll="goscroll">
		<div class="title" style="display: flex;">
			<!-- <span @click="go" style="margin-left: 20px;">返回</span>
			<el-divider direction="vertical"></el-divider> -->
            <el-button type="primary" style="margin-left: 20px;" @click="go">返回</el-button>
            <div style="padding-left:50px;">
                <el-button type="primary" icon="el-icon-printer"  v-print="printObj" >打印</el-button>
            </div>
            
            
		</div>
        <div style="padding: 30px;">

       
        <div id="printMe" ref="printContent" class="content">
            <div style="display: flex;align-items: center;justify-content: center;">
                出库单通知单
            </div>
            <div style="height:10px;"></div>
		<!-- <div> -->
			<el-form v-model="storelinks">
				<div style="display: flex;justify-content: space-between;height:30px;">
                    
                    <el-form-item  label="出库类型:" style="width: 25%;">
                        <span>{{storelinks.orderTypeName}}</span>
					</el-form-item>
					<el-form-item label="来源单号" style="width: 25%;">
                        <span>{{storelinks.orderSource}}</span>
					</el-form-item>
					<el-form-item label="客户订单号" style="width: 25%;">
                        <span>{{storelinks.customerOrderCode}}</span>
					</el-form-item>
					<el-form-item label="仓库" style="width: 25%;">
                        <span>{{storelinks.warehouseName}}</span>
					</el-form-item>
				</div>
				<div style="display: flex;justify-content: space-between;height:30px;">
					<el-form-item label="出库单号:" style="width: 25%;">
                        <span>{{storelinks.orderCode}}</span>
					</el-form-item>
					<el-form-item label="总体积(m³):" style="width: 25%;">
                        <span>{{storelinks.volume}}</span>
					</el-form-item>
					<el-form-item label="总重量(kg):" style="width: 25%;">
                        <span>{{storelinks.weight}}</span>
					</el-form-item>
					<el-form-item label="备注:" style="width: 25%;">
                        <span>{{storelinks.memo}}</span>
					</el-form-item>  
                </div>
				<div style="display: flex;height:30px;">
					<el-form-item label="客户:" style="width: 30%;">
                        <span>{{storelinks.customerName}}</span>
					</el-form-item>
					<el-form-item label="收货地址:" style="width: 45%;">
                        <span>{{storelinks.tdogAddress}}</span>
					</el-form-item>
					<el-form-item label="收货单位:" style="width: 25%;">
                        <span>{{storelinks.tdogGunit}}</span>
					</el-form-item>
					
				</div>
				
                <div style="height:30px;">
                    <el-form-item label="打印时间:" >
                        <span>{{storelinks.lastPrintDatetime}}</span>
                        <span style="padding-left:10px;">第</span>
                        <span style="padding:0 5px;">{{storelinks.printTimes}}</span>
                        <span>次打印</span>
					</el-form-item>   
                </div>
				
				<div style="width: auto;position: relative;">
                    <table  cellspacing="0" cellpadding="0" border="1" style="background-color: #fff;">
                        <thead>
                            <tr>
                                <td>商品编号</td>
                                <td style="width:300px;">商品名称</td>
                                <td>商品状态</td>
                                <td>批次</td>
								<td>库位</td>
                                <td style="width:60px;">计划数</td>
                                <td style="width:80px;">计划数EA</td>
                                <td style="width:60px;">实出</td>
                                <td>备注</td>
                            </tr>
                        </thead>
                        <tbody >
                            <tr v-for="(item, index) in dataList" :key="index"  v-if="item.pdtCode!=''">
                                <td>{{ item.pdtCode }}</td>
                                <td>{{ item.pdtName }}</td>
                                <td>{{ item.goodsStatusName }}</td>
                                <td>{{ item.batchNo }}</td>
								<td>{{ item.warehouseLocationName }}</td>
                                <td>{{ item.num }}</td>
                                <td>{{ item.eaNum }}</td>
                                <td>{{ item.qtyReceived }}</td>
                                <td>{{ item.remark }}</td>
                            </tr>
                        </tbody>
                    </table>
                    
				</div>
				<div style="display: flex;padding-top:20px;height:30px;">
					<el-form-item label="制单人:" style="width: 25%;">
                        <span>{{ storelinks.createBy }}</span>
					</el-form-item>
					<el-form-item label="仓管员:" style="width: 25%;">
                        <span>{{ storelinks.receiver }}</span>
					</el-form-item>
					<el-form-item label="提货人:" style="width: 25%;">
                        <span>{{ storelinks.picker }}</span>
					</el-form-item>
					<el-form-item label="装卸组:" style="width: 25%;">
                        <span>{{ storelinks.stevedore }}</span>
					</el-form-item>
					<el-form-item label="司机:" style="width: 25%;">
                        <span>{{ storelinks.driver }}</span>
					</el-form-item>
					<el-form-item label="车牌:" style="width: 25%;">
                        <span>{{ storelinks.carNo }}</span>
					</el-form-item>
					<el-form-item label="" style="width: 25%;">
						<span>第1页/共1页</span>
					</el-form-item>
				</div>
				<!-- <div style="display: flex;height:30px;">
					<el-form-item label="作业开始时间:" style="width: 50%;">
                        <span>{{ storelinks.beginDatetime }}</span>
					</el-form-item>
					<el-form-item label="作业结束时间:" style="width: 50%;">
                        <span>{{ storelinks.endDatetime }}</span>
					</el-form-item>
				</div> -->
			</el-form>
		<!-- </div> -->
		
		</div>
	
		</div>
	</div>
</template>

<script>
	export default {
		// props:['order'],
		// name: "GoodsZoom",
		components: {
		},
		data() {
			let that = this
			return {
				isReturn:true,
				detaillist: {},
				unitList: [],
				arsList:[],
				queryParam: '',
				isJoinCar:3,
				driverList:[],
				num: 1,
				flag:false,
				userList: [],
				storelinks: {
					status:0,
					number:0,
					billingType:1,
                    orderType: '', //typeList[0].typeKey
                    warehouseId: '', //entrepotList[0].id
                    customerId: '', //userList[0].id
					sendDate:this.Date()
				},
				orderInfo: {},
				goodsList: [],
				form: {},
				dataList: [],
				formData: {},
				
				goodsDataList: [],
				contractList: [],
				typeList: [],
				ids:'',
				aid:0,
				carNumberplate:'',
				routeList: [],
                isDataChangeCount:0,
                
                entrepotList: [],
                locationList: [],
                stateOfGoodsList: [], //货物状态
                orderID: '',
                pageTile: '',

                printObj: {
                    id: 'printMe',//id
                    popTitle: "入库通知单",//自定义设置标题
                    extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                    preview: false, // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                    previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
                    previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                    zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）   
                    previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
                    previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
                    beforeOpenCallback() {
						// that.aa();
						// console.log('xixxi')
					}, // 开启打印前的回调事件
                    openCallback() {}, // 调用打印之后的回调事件
					closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
					clickMounted() { 
						// console.log('点击v-print绑定的按钮了！')
						// that.aa();
						that.$api.outboundDeliveryPrint({
							orderId : that.$route.query.id
						}).then(res=>{
							if(res.state = 'success'){
								let info = JSON.parse(res.data.content);
								that.storelinks.lastPrintDatetime = info.lastPrintDatetime;
								that.storelinks.printTimes = info.printTimes;
								// console.log('1111--', res.data)
								// console.log('122--', JSON.parse(res.data.content))
							}
						})
					}, //点击v-print绑定的按钮了！
                    url: '',
                    standard: '',
                    extraCss: '',
                },
            }
		},
		watch: {
			carNumberplate(newValue, oldValue) {
				this.isJoinCar=this.arsList.find(item=>item.carNumberplate==newValue).isJoinCar
			},
			storelinks:{
				handler(a,b){
					if(this.$route.query.id){
						this.isDataChangeCount++
					}else{
						this.isDataChangeCount++

					}
					
				},
				deep:true
			},
			'storelinks.routeId'(a,b){
			
				if(!this.$route.query.id){
					if(this.storelinks.billingType==1){
					
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceTrips
					
					}else if(this.storelinks.billingType==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceVolume*this.storelinks.number
					}else if(this.storelinks.billingType==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceWeight*this.storelinks.number
					
					}
					this.storelinks.driveSendReward=this.routeList.find(item=>item.id==a).driveSendReward
				}else{
					if(this.isDataChangeCount>1){
						if(this.storelinks.billingType==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceTrips
						
						}else if(this.storelinks.billingType==2){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceVolume*this.storelinks.number
						}else if(this.storelinks.billingType==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceWeight*this.storelinks.number
						
						}
						this.storelinks.driveSendReward=this.routeList.find(item=>item.id==a).driveSendReward
					}
				}
			
					
				
			},
			
			'storelinks.billingType'(a,b){
				if(!this.$route.query.id){
					if(a==1){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
						
					}else if(a==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*this.storelinks.number
					}else if(a==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*this.storelinks.number
					
					}
				}else{
					if(this.isDataChangeCount>1){
						if(a==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
				
						}else if(a==2){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*this.storelinks.number
						}else if(a==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*this.storelinks.number
						
						}
					}
				}
				
				
			},
			'storelinks.number'(a,b){
				if(!this.$route.query.id){
					if(this.storelinks.billingType==1){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
					}else if(this.storelinks.billingType==2){
					this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*a
					}else if(this.storelinks.billingType==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*a
					
					}
				}
				else{
					if(this.isDataChangeCount>1){
						if(this.storelinks.billingType==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
						}else if(this.storelinks.billingType==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*a
						}else if(this.storelinks.billingType==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*a
						
						}
					}
				}
			},
			
		},
		
		methods: {
             getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '数量合计';
                    return;
                }
                if (index === 1) {
                    sums[index] = '';
                    return;
                }
                if (index === 2) {
                    sums[index] = '';
                    return;
                }
                if (index === 3) {
                    sums[index] = '';
                    return;
                }
                if (index === 7) {
                    sums[index] = '';
                    return;
                }
                if (index === 8) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                    }, 0);
                    sums[index] += ' ';
                } else {
                    sums[index] = '';
                }
                });

                return sums;
                
            },
            dialogVisible(){

            },
			customerSelect(e){
                let obj = {};
				obj = this.userList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
                });
                this.storelinks.customerName = obj.customerName
            },
			carchange(it){
				
			},
			Date(){
				 const now = new Date();
					const year = now.getFullYear(); // 获取当前年份
					const month = now.getMonth() + 1; // 月份从 0 开始，所以要加1
					const day = now.getDate(); // 获取当前日期
				return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
			},
			wanc(){
				
				this.$api.completeByID(this.orderInfo.id).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.init();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			changesj(e){
				
				this.carNumberplate=e.carNumberplate
			},
            handleRowClick(row, event, column) {
                // row 对象即为点击的行数据
                this.$nextTick(()=>{
                    this.aid=row.id
                })
            },
			change(e){
			
				this.ids=e
			},
			asd(a,e){
				// console.log('9000--', this.goodsDataList[this.ids])
				// this.$set(this.dataList,a,{
				// 	goodsName: this.goodsDataList[this.ids].goodsName,
				// 	id:this.dataList[a].id,
				// 	goodsId:this.goodsDataList[this.ids].goodsId,
				// 	customerOrderCode:this.goodsDataList[this.ids].customerOrderCode,
				// 	pdtCode: this.goodsDataList[this.ids].pdtCode,
				// 	unitName: this.goodsDataList[this.ids].unitName,
                // })
                
				// this.$set(this.dataList[a],'goodsName',this.goodsDataList[this.ids].goodsName)
				// this.$set(this.dataList[a],'goodsId',this.goodsDataList[this.ids].goodsId)
				// this.$set(this.dataList[a],'customerOrderCode',this.goodsDataList[this.ids].customerOrderCode)
				this.$set(this.dataList[a],'pdtCode',this.goodsDataList[this.ids].pdtCode)
				this.$set(this.dataList[a],'unitName',this.goodsDataList[this.ids].unitName)
                this.$set(this.dataList[a],'id',this.dataList[a].id)
                this.$set(this.dataList[a],'pdtName',this.goodsDataList[this.ids].pdtName)
                this.$set(this.dataList[a],'pdtId',this.goodsDataList[this.ids].pdtId)
                
            },
            kuwei(a,e){
                // this.$set(this.dataList[a],'pdtCode',this.goodsDataList[this.ids].pdtCode)
				// this.$set(this.dataList[a],'unitName',this.goodsDataList[this.ids].unitName)
                // this.$set(this.dataList[a],'id',this.dataList[a].id)
                // this.$set(this.dataList[a],'pdtName',this.goodsDataList[this.ids].pdtName)
				// this.$set(this.dataList[a],'pdtId',this.goodsDataList[this.ids].pdtId)
            },
			keydown(index,b){ //键盘回车事件
				let a='sel'+(index+1)
				
				let data={
					orderId:this.orderInfo.id,
					pdtName:b.pdtName,
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					unitName:b.unitName,
					remark:b.remark,
                    num:b.num,
                    eaNum: b.eaNum,
                    goodsStatus: b.goodsStatus,
                    qtyReceived: b.qtyReceived,
                    // volume: b.volume,
                    // weight: b.weight,
                    batchNo: b.batchNo,
                    warehouseLocationId: b.warehouseLocationId
				}
				// console.log('编辑或新增的表格数据---', data)		
				if(b.id){ //编辑
					this.$api.updateWarehouseWarranOrderList({...data, id:b.id}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							this.dataList=res.data
							this.$nextTick(()=>{
								document.getElementById(a).focus();
							})
							this.handleAdd()
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addWarehouseWarranOrderList(data).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							this.dataList=res.data
							this.$nextTick(()=>{
								document.getElementById(a).focus();
							})
							this.handleAdd()
						}else{
							this.$message.error(res.message)
						}
					})
				}
				
			},
			submitClick(){
                if(this.storelinks.warehouseId){}else{
                    this.$message.error('入库仓库不能为空');
                    return
                }

                if(this.storelinks.orderType){}else{
                    this.$message.error('订单类型不能为空');
                    return
                }

                if(this.storelinks.customerId){}else{
                    this.$message.error('客户不能为空');
                    return
                }

                if(this.storelinks.orderCode){}else{
                    this.$message.error('入库单号不能为空');
                    return
                }
               
                if(this.storelinks.customerOrderCode){}else{
                    this.$message.error('客户订单号不能为空');
                    return
                }
                let data={
                    // ...this.storelinks,
                    warehouseId: this.storelinks.warehouseId, //入库仓库
                    orderType: this.storelinks.orderType, //订单类型
                    orderCode: this.storelinks.orderCode, //入库单号
                    customerId: this.storelinks.customerId, //客户
                    customerName: this.storelinks.customerName, //客户名称
                    csource: this.storelinks.csource, //供货单位
                    customerOrderCode: this.storelinks.customerOrderCode, //客户订单号
                    carNo: this.storelinks.carNo, //车牌号码
                    // volume: this.storelinks.volume, //体积
                    // weight: this.storelinks.weight, //重量
                    receiver: this.storelinks.receiver, //收货人
                    stevedore: this.storelinks.stevedore, //装卸组
                    memo: this.storelinks.memo, //备注
                    beginDatetime: this.storelinks.beginDatetime, //开始时间
                    endDatetime:this.storelinks.endDatetime, //结束时间
                }
                // console.log('点击提交按钮提交的数据---', data)
                // this.$encrypt(data)
                if(this.orderID){ //编辑
                    data.id = this.orderID,
                    this.$api.updateWarehouseWarranOrder(data).then(res=>{
                        if (res.state == 'success') {
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            // setTimeout(()=>{
                            //     this.$router.go(-1)
                            // },1000)
                            this.isDataChangeCount--;
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                }else{
                    this.$api.addWarehouseWarranOrder(data).then(res=>{
                        if (res.state == 'success') {
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            // setTimeout(()=>{
                            //     this.$router.go(-1)
                            // },1000)
                            this.pageTile = '编辑';
                            this.orderID = res.data.id;
                            this.orderInfo = res.data;
                            this.storelinks = res.data;
                            this.isDataChangeCount--;
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                }
				
			},
			tableBC(index,b){ //表格操作列保存事件
				let a='sel'+(index+1)
				
				let data={
					orderId:this.orderInfo.id,
					pdtName:b.pdtName,
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					unitName:b.unitName,
					remark:b.remark,
                    num:b.num,
                    eaNum: b.eaNum,
                    goodsStatus: b.goodsStatus,
                    qtyReceived: b.qtyReceived,
                    // volume: b.volume,
                    // weight: b.weight,
                    batchNo: b.batchNo,
                    warehouseLocationId: b.warehouseLocationId
				}
				// console.log('编辑或新增的表格数据---', data)		
				if(b.id){ //编辑
					this.$api.updateWarehouseWarranOrderList({...data, id:b.id}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							this.dataList=res.data
							this.$nextTick(()=>{
								document.getElementById(a).focus();
							})
							this.handleAdd()
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addWarehouseWarranOrderList(data).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							this.dataList=res.data
							this.$nextTick(()=>{
								document.getElementById(a).focus();
							})
							this.handleAdd()
						}else{
							this.$message.error(res.message)
						}
					})
				}
				
			
			},
			
			
			select(a,item,index) {
				// console.log('122--',item);
				// console.log('133--',this.dataList);
			   // this.dataList[a]=item
				this.$set(this.dataList[a],'pdtName',item.pdtName)
				this.$set(this.dataList[a],'pdtId',item.pdtId)
				this.$set(this.dataList[a],'index',index)
				this.$set(this.dataList[a],'pdtCode',item.pdtCode)
				this.$set(this.dataList[a],'unitName',item.unitName)
            },
            kuweiSelect(a,item,index) {
			   // this.dataList[a]=item
				// this.$set(this.dataList[a],'pdtName',item.pdtName)
				// this.$set(this.dataList[a],'pdtId',item.pdtId)
				// this.$set(this.dataList[a],'index',index)
				// this.$set(this.dataList[a],'pdtCode',item.pdtCode)
				// this.$set(this.dataList[a],'unitName',item.unitName)
            },
			// 添加行
			handleAdd() {
				var _this = this

				let list = {
					pdtName: '',
					remark: '',
					
					unitName: '',
				}

				_this.dataList.push(list)
			},
			// 删除行
			handleDelete(index, row) {
				var _this = this
				this.$api.deldWarehouseWarranOrder(row.id).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						_this.dataList.splice(index, 1)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			input(e) {
				this.goodsDataList=[]
				this.$api.findgs(this.$encrypt({
					queryParam: e
				})).then(res => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.data.length > 0) {
						res.data.forEach((item,index)=> {
                            // console.log('下拉选择的商品信息---', item)
							this.goodsDataList.push({
								pdtName: item.pdtName,
								pdtId:item.id,
								pdtCode: item.pdtCode,
                                unitName: item.unitName,
							}) 
						})
						this.flag=true
					} else {
						this.goodsDataList = []
					}


				})
			},
			goscroll(e) {
			
			},
			goBack() {
				topTarget.scrollIntoView();
			},
			inputBlur(index,b,c){ //表格输入框失焦事件
				let a='sel'+(index+1)
				let data={
					orderId:this.orderInfo.id,
					pdtName:b.pdtName,
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					unitName:b.unitName,
					remark:b.remark,
                    num:b.num,
                    eaNum: b.eaNum,
                    goodsStatus: b.goodsStatus,
                    qtyReceived: b.qtyReceived,
                    // volume: b.volume,
                    // weight: b.weight,
                    batchNo: b.batchNo,
                    warehouseLocationId: b.warehouseLocationId
				}
				// console.log('编辑或新增的表格数据---', data)		
				if(b.id){ //编辑
					this.$api.updateWarehouseWarranOrderList({...data, id:b.id}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							this.dataList=res.data
							this.$nextTick(()=>{
								document.getElementById(a).focus();
							})
							this.handleAdd()
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addWarehouseWarranOrderList(data).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							this.dataList=res.data
							this.$nextTick(()=>{
								document.getElementById(a).focus();
							})
							this.handleAdd()
						}else{
							this.$message.error(res.message)
						}
					})
				}
				
			},
			go() {  
                // console.log('未知---', this.isDataChangeCount)
				if(this.storelinks.status==5){
					this.$router.go(-1)
				}else{
					if(this.$route.query.id){
						if(this.isDataChangeCount>1){
							this.$message.error('还有待提交数据，请先提交')
						}
						else{
							this.$router.go(-1)
						}
					}else{
						if(this.isDataChangeCount>0){
							this.$message.error('还有待提交数据，请先提交')
						}
						else{
							this.$router.go(-1)
						}
					}
				}
				
				
				
            },
            getCurrentTime() {
                const currentTime = new Date().toLocaleString();; // 创建一个表示当前日期和时间的Date对象
                // console.log('33--', currentTime)
                return currentTime;
            },
            aa(){
                this.$api.outboundDeliveryPrint({
                   orderId : this.$route.query.id
                }).then(res=>{
					if(res.state = 'success'){
						let info = JSON.parse(res.data.content);
						this.storelinks.lastPrintDatetime = info.lastPrintDatetime;
						this.storelinks.printTimes = info.printTimes;
						// console.log('1111--', res.data)
						// console.log('122--', JSON.parse(res.data.content))
					}
                })
            },
            init(){ //编辑查询
                // this.aa();
				this.$api.getOutboundDeliveryOrderInfoByID(this.$route.query.id).then(res=>{
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					this.storelinks=res.data
					// this.formData = JSON.parse(JSON.stringify(res.data))
                    // console.log('根据ID查询--', res.data)
                    this.orderID = res.data.id;
					this.orderInfo = res.data;
                    this.dataList = res.data.listChildren;
                    // console.log('133--', this.dataList)

					if(this.storelinks.status==2){ //0=制单中；1=入库中，2=关单
					
					}else{
					
						this.dataList.push({
							pdtId: '',
                            pdtName: '',
                            remark: '',
                            unitName: '',
                            pdtCode: '',
						})
					
					
					}
					
				})
			},
			save(type) {
                // console.log(`调用保存按钮方法--${type}`);
            },
			saveContent(e) {
			   var key = window.event.keyCode ? window.event.keyCode : window.event.which;
			   if (key === 83 && e.ctrlKey) {
			     this.save("hot key");
			     e.preventDefault(); //阻止浏览器默认事件
			   }
            },
            WarehouseLis(e){
                this.$api.getWarehouseListByNowUser({
                    status: 1,
                    warehouseName: e
				}).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.entrepotList = res.data
					}
				})
            },
            getStateOfGoodsListI(){ //货物状态查看
                this.$api.getStateOfGoodsList().then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.stateOfGoodsList = res.data
					}
				})
            },
            districtFocus(e){ //库区选择 - 库位查询
                this.$api.getLocationListNoParameter({
                    warehouseLocationName: e,
                    warehouseId: this.storelinks.warehouseId,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
			},
		},
		beforeDestroy() {
		    //销毁时移除监听
		    document.removeEventListener("keydown", this.saveContent);
		},
		mounted() {
			document.addEventListener("focus", this.saveContent);
		},
		created() {
			if(this.$route.query.id){
				this.init()
            }
           this.getCurrentTime();
		}
	}
</script>
<style lang="less" scoped>
    table {
   font-family: Arial, sans-serif;
   font-size: 14px;
   background-color: #f0f2f5;
   border-collapse: collapse;
   color: #454545;
   table-layout: auto;
   width: 100%;
   text-align: center;
   border-bottom-width: 1px;
   border-bottom-style: solid;
   border-bottom-color: #dadcde;
   thead {
     border-top-width: 1px;
     border-top-style: solid;
    border-top-color: #dadcde;
     line-height: 40px;
    font-weight: bold;
     color: #454c70;
   }
   tr {
     border-top-width: 1px;
     border-top-style: solid;
    border-top-color: #dadcde;
    line-height: 23px;
   }
   td{
     padding: 5px 10px;
    font-size: 14px;
     font-family: Verdana;
     width: 100px;
     word-break: break-all; // 元素换行
  }
   // 斑马纹效果stripe
   tr:nth-child(even) {
     background: #F5F7F9;
   }
   tr:nth-child(odd) {
    background: #FFF;
  }
 }
 .table-empty {
   min-height: 60px;
  text-align: center;
   width: 100%;
   height: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   border-bottom: 1px solid #ebeef5;
  .table-empty-text {
     line-height: 60px;
     width: 50%;
   color: #909399;
 }
}
</style>
<style media="print" lang="less">
   @page {
       size:  241mm 159.5mm !important;
   	margin: 0 !important;
   }
    

    @media print {
        html {
            background-color: #ffffff;
            height: auto;
            margin: 0px;
            zoom: 89%;
        }
        // .content {
        //     transform: scale(0.95); /* 设置缩放比例 */
        //     transform-origin: top left; /* 确保从左上角开始缩放 */
        // }
        body {
            border: solid 1px #ffffff;
            // margin: 10mm 15mm 10mm 15mm;
            margin: 0 !important;
            padding: 0 !important;
        }
        /deep/ table {
            table-layout: auto !important;
        }
        /deep/ #pagetable table{
            table-layout: fixed !important;
        }
        .el-table__header-wrapper .el-table__header {
            width: 100% !important;
            border: solid 1px #f2f2f2;
        }
        .el-table__body-wrapper .el-table__body {
            width: 100% !important;
        }
        #pagetable table {
            table-layout: fixed !important;
        }
	}
	.client-name{
		text-align: center;
	}
</style>